<div [formGroup]="form()">
  <div class="row">
    <div
      class="col-12 form-group form-floating icon-start"
      [class.invalid]="
        form().controls['linkedin'].invalid &&
        (form().controls['linkedin'].dirty || submitAttempt())
      "
    >
      <fa-icon [icon]="icons.linkedin" size="lg"></fa-icon>
      <input
        type="url"
        class="form-control"
        formControlName="linkedin"
        id="profileLinkedin"
        autocomplete="off"
        [placeholder]="'jobboard.platform.profile.sections.social.linkedin' | transloco"
      />
      <label for="profileLinkedin">{{
        'jobboard.platform.profile.sections.social.linkedin' | transloco
      }}</label>
      <div class="validation">
        @if (
          form().controls['linkedin'].hasError('start') &&
          (form().controls['linkedin'].dirty || submitAttempt())
        ) {
          <p>{{ 'jobboard.platform.profile.sections.social.url-not-valid' | transloco }}</p>
        }
      </div>
    </div>
    <div
      class="col-12 form-group form-floating icon-start"
      [class.invalid]="
        form().controls['xing'].invalid &&
        (form().controls['xing'].dirty || submitAttempt())
      "
    >
      <fa-icon [icon]="icons.xing" size="lg"></fa-icon>
      <input
        type="url"
        class="form-control"
        formControlName="xing"
        id="profileXing"
        autocomplete="off"
        [placeholder]="'jobboard.platform.profile.sections.social.xing' | transloco"
      />
      <label for="profileXing">{{
        'jobboard.platform.profile.sections.social.xing' | transloco
      }}</label>
      <div class="validation">
        @if (
          form().controls['xing'].hasError('start') &&
          (form().controls['xing'].dirty || submitAttempt())
        ) {
          <p>{{ 'jobboard.platform.profile.sections.social.url-not-valid' | transloco }}</p>
        }
      </div>
    </div>
  </div>
</div>
